import BussinesLogo from './bussinesLogo.png';
import WhatsApp from './iconWhatsApp.png';
import Facebook from './iconFacebook.png';
import Instagram from './iconInstagram.png';
import Youtube from './iconYouTube.png';
import Menu from './iconMenu.png';
import AreaAluno from './AreaAluno.png';
import slidRight from './iconNext.png';
import slidLeft from './iconBack.png';
import saude from './saude.png';
import tecnologia from './tecnologia.png';
import beleza from './beleza.png';
import mecanica from './mecanica.png';
import reticencia_left from './reticencia_left.png';
import reticencia_rigth from './reticencia_rigth.png';
import noticia from './noticia_tamb.jpg';
import profissional from './profissional.jpg';
import fachada from './fachada.png';
import location from './location.png';
import ocult from './ocultIcon.png';
import view from './viewIcon.png';
import NoIMG from './NoIMG.png';
import close from './close.png';
import BussinesLogoV2 from './bussinesLogoV2.png';
import admin from './admin.png';
import idioma from './idioma.png';
import recpecao from './Recepção.jpg';
import auditorio from './Auditorio.jpg';
import laboratorio from './Laboratorio.jpg';
import Fachada from './Fachada.jpg';
import BemVindo from './BemVindo.png';
import Profissoes from './Profissões.png';
import FuturoEmMovimento from './Seu Futuro em Movimento.jpg';
import FuturoEmMovimentoMobile from './Feed Seu Futuro em Movimento.png';
import Hardware from './Hardware.jpg';
import HardwareMobile from './Hardware Mobile.jpg';
import Informatica from './Informática.jpg';
import InformaticaMobile from './Informática Mobile.jpg';
import Farmacia from './Farmácia.jpg';
import FarmaciaMobile from './Farmácia Mobile.jpg';
import CertificadoPremium from './CertificadoPremium.png';
import home from './home.png';
import SearchWhite from './SearchWhite.png';
import AlunoAprendiz from './AlunoAprendiz.png';
import LogoCapacita from './LogoCapacita.png';
import CamisetaDeCostas from './CamisetaDeCostas.jpg';
import CamisetaDeFrente from './CamisetaDeFrente.jpg';


const icons = {
    BussinesLogo,
    WhatsApp,
    Facebook,
    Instagram,
    Youtube,
    Menu,
    AreaAluno,
    slidRight,
    slidLeft,
    saude,
    tecnologia,
    beleza,
    mecanica,
    reticencia_left,
    reticencia_rigth,
    noticia,
    profissional,
    fachada,
    location,
    ocult,
    view,
    NoIMG,
    close,
    BussinesLogoV2,
    admin,
    idioma,
    recpecao,
    auditorio,
    laboratorio,
    Fachada,
    BemVindo,
    Profissoes,
    Hardware,
    HardwareMobile,
    Informatica,
    InformaticaMobile,
    Farmacia,
    FarmaciaMobile,
    CertificadoPremium,
    home,
    SearchWhite,
    FuturoEmMovimento,
    FuturoEmMovimentoMobile,
    AlunoAprendiz,
    LogoCapacita,
    CamisetaDeCostas,
    CamisetaDeFrente
}

export const Styled = {
    icons
}

export default icons;